import { Button, ICON_COLOR } from '@zep-us/zus';
import { XSmallIcon } from '@zep-us/zus-icons';
import { useAiBuilderChatCopy } from '../hooks/useAiBuilderChatCopy';
import type { AiBuilderSelectedQuizContext } from '../store';
type AiBuilderSelectedQuizContextChipProps = {
  context: AiBuilderSelectedQuizContext;
  onClear: () => void;
  disabled?: boolean;
};
export const AiBuilderSelectedQuizContextChip = ({
  context,
  onClear,
  disabled = false
}: AiBuilderSelectedQuizContextChipProps) => {
  const copy = useAiBuilderChatCopy();
  return <div className="flex min-w-0 max-w-full flex-wrap items-start gap-xs" data-sentry-component="AiBuilderSelectedQuizContextChip" data-sentry-source-file="AiBuilderSelectedQuizContextChip.tsx">
      <Button type="button" variant="outlined" intent="neutral" size="sm" rounded="default" className="max-w-[180px] overflow-hidden border border-opacity-assistive bg-neutral text-caption-lg-semibold" aria-label={copy.selectedQuizContext.clearAriaLabel(context.number)} disabled={disabled} rightSlot={<XSmallIcon size="xs" fill={ICON_COLOR.neutral} aria-hidden="true" />} onClick={onClear} data-sentry-element="Button" data-sentry-source-file="AiBuilderSelectedQuizContextChip.tsx">
        <span className="min-w-0 truncate">
          {copy.selectedQuizContext.label(context.number)}
        </span>
      </Button>
    </div>;
};